import styled from '@emotion/styled'

export const BadgeWrapper = styled.div`
  padding-top: 1px;
  margin-right: 10px;
`
